import React, { PropTypes } from 'react';
import ReactTooltip from 'react-tooltip';

export default class CondensedButton extends React.Component {

	render () {		
		return (			
			<div className={`${this.props.className} cs-card`} onClick={() => this.props.onClick()}>
				<i className="fa fa-caret-down fa-2x pointer" style={{margin: "auto"}} data-tip={this.props.tooltip} />
				<ReactTooltip />
			</div>			
		);
	}
}

CondensedButton.propTypes = {
	tooltip: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/CondensedButton.js